<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <!-- Page Header -->
        <v-row align="center" justify="center" class="mt-n4">
          <v-col cols="12" md="auto">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">mdi-note-plus-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Notas de Débito</div>
                <div class="text-caption grey--text">Consulta y gestiona las notas de débito</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Filters -->
        <v-row justify="center">
          <v-col cols="12">
            <search-header-po @dataFilters="changeBusiness($event)" />
          </v-col>
        </v-row>
        <v-card class="rounded-lg mt-3">
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              :search="search"
              :headers="headers"
              :items="invoices"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-toolbar-title>Notas de credito</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Buscar..."
                    class="mt-6"
                    v-model="search"
                  ></v-text-field>
                  <v-spacer></v-spacer>

                  <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="lastFilters.location != 0 && hasFeature('SHOP-172')"
                        @click="editOrCopyStatus = false"
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>add</v-icon>
                        Nueva nota debito
                      </v-btn>
                      <span v-else>Selecciona una sucursal</span>
                    </template>
                    <v-card style="background-color: #f4f5fa">
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12" md="12">
                            <invoice
                              v-if="dialog"
                              :type="4"
                              :type_invoice="1"
                              :editOrCopy="editedItem"
                              :itbis="itbis"
                              :credit_days="credit_days"
                              :ncfTypes="ncfTypes"
                              :withholdings="withholdings"
                              :boxes="boxes"
                              :accounts="accounts"
                              :itemsLocations="itemsLocations"
                              :invoice_categories="invoice_categories"
                              :itemsDepartments="itemsDepartments"
                              :editOrCopyStatus="editOrCopyStatus"
                              @close-dialog="clear()"
                              @save-note="save($event)"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-text>
                        <v-row> </v-row>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.id`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showNote(item.id)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                    {{ item.invoice_note_number }}</span
                  >
                </v-hover>
              </template>
              <template v-slot:[`item.invoice_number`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showInvoice(item.invoice_id)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                    {{ item.invoice_number }}</span
                  >
                </v-hover>
              </template>
              <template v-slot:[`item.total_amount`]="{ item }">
                <span
                  >{{ currencyFormat(item.total_amount) }} {{ item.currency_code }}
                </span>
              </template>
              <template v-slot:[`item.entity_name`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="viewEntity(item.entity_id)"
                    style="font-size: 14px"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                    >{{ item.entity_name }}</span
                  ></v-hover
                >
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip small outlined color="success" v-if="item.status">
                  Activa
                </v-chip>
                <v-chip small outlined color="red" v-else> Anulada </v-chip>
              </template>

              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template> -->
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6"> No hay datos </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    lastFilters: {},
    loading: false,
    dialog: false,
    dialogDelete: false,
    suplidor: false,
    cliente: false,
    disabledName: false,
    plazoPagoSuplidor: null,
    plazoPagoCliente: null,
    documents: [],
    rncValid: false,
    ncfTypes: [],
    accounts: [],
    itbis: [],
    provincies: [],
    invoices: [],
    cxc: "",
    cxp: "",
    itemsLocations: [],
    selectedDocument: "",
    selectedtypesNcfCliente: "",
    selectedtypesNcfSuplidor: "",
    selectedProvincies: "",
    headers: [
      {
        text: "Nota",
        align: "start",

        value: "id",
      },
      {
        text: "Factura",
        align: "start",

        value: "invoice_number",
      },
      { text: "Unidad negocio", value: "business_unit_description" },
      { text: "Location", value: "location_description" },
      { text: "Cliente", value: "entity_name" },
      { text: "Total", value: "total_amount", align: "end" },
      { text: "Status", value: "status" },

      //{ text: "Actions", value: "actions", sortable: false },
    ],
    editOrCopyStatus: false,
    itemsDepartments: [],
    credit_days: [],
    ncfTypes: [],
    invoice_categories: [],
    withholdings: [],
    editedIndex: -1,
    editedItem: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo contacto" : "Editar contacto";
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    async getData(data) {
      this.lastFilters = data;
      this.loading = true;
      let filters = "";
      filters += "where invoices.invoice_type_id in(1,2,3,4,5,8) and note_type='DEBIT' ";
      filters +=
        data.business == null
          ? " "
          : " AND  BUSINESS_UNITS.ID in (" + data.business + ") ";
      filters +=
        data.location == null || data.location == 0
          ? ""
          : " AND INVOICES.LOCATION_ID IN (" + data.location + ")";
      filters +=
        data.department_id == null || data.department_id == 0
          ? ""
          : " AND DEPARTMENT_ID =" + data.department_id + "";
      filters +=
        " AND EFFECTIVE_DATE::DATE BETWEEN '" +
        data.dateStart +
        "' and '" +
        data.dateEnd +
        "' ";
      let resultInvoices = await this.api_Post("income/note_list", {
        filters: filters,
      });

      this.invoices = await resultInvoices.json();
      this.loading = false;
    },
    clear() {
      this.editedItem = null;
      this.dialog = false;
    },
    async initialize() {
   
      const result = await Promise.all([
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("humanResource/locations"),
        this.api_Get("income/boxes"),
        this.api_Get("accounting/withholdings"),
        this.api_Get("income/invoice_categories"),
        this.api_Get("accounting/nfc_types"),
        this.api_Get("accounting/credit_days"),
        this.g_departments(),
      ]);

      this.itbis = await result[0].json();

      for (let item of await result[1].json()) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          id: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      for (let item of await result[2].json()) {
        for (let item2 of this.$store.state.auth.locations) {
          if (item2.id == item.id) {
            this.itemsLocations.push({
              value: item.id,
              text: item.desc_loc_long,
              id: item.id,
              bus_id: item.bus_id,
              desc_bus_short: item.desc_bus_short,
              desc_bus_long: item.desc_bus_long,
              desc_loc_short: item.desc_loc_short,
              desc_loc_long: item.desc_loc_long,
              city_id: item.city_id,
              city_description: item.city_description,
              location_adress: item.location_adress,
              status_id: item.status_id,
              catalogue_id: item.catalogue_id,
              catalogue_name: item.catalogue_name,
              rnl: item.rnl,
              representative_name: item.representative_name,
              sta_description: item.sta_description,
              employee_representative_id: item.employee_representative_id,
            });
          }
        }
      }
      this.boxes = await result[3].json();
      this.withholdings = await result[4].json();
      this.invoice_categories = await result[5].json();
      this.ncfTypes = await result[6].json();
      this.ncfTypes.unshift({ id: 0, name: "SIN COMPROBANTE" });
      this.credit_days = await result[7].json();
      this.itemsDepartments = await result[8];
      //   this.getData({busines:null,location:this.$store.state.auth.user.acces_finance[0].locations});
    },
    changeBusiness(data) {
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
      //   this.getData(data.data)
      // if(data.data.busines)
    },
    editItem(item) {
      this.editOrCopyStatus = true;
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(data) {
      this.loadingSave = true;

      this.getData(this.lastFilters);

      this.showNote(data[0].id, true);
      this.dialog = false;

      this.loadingSave = false;
    },
  },
};
</script>

<style></style>
